'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.millisecondsSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/millisecondsSince.js
// module id = 335
// module chunks = 0